module.exports = __webpack_public_path__ + "img/mini-logo.bf141cfc.png";